import styles from "./Spinner.module.css";

export default function Spinner({ width }) {
  return <span className={styles.loader} style={{ "--width": width }}></span>;
}
